import {
  CalendarBlank,
  CaretDown,
  MagnifyingGlass,
  SortAscending,
} from '@phosphor-icons/react'
import React from 'react'

interface DropInHeaderProps {
  params: any
  setParams: React.Dispatch<React.SetStateAction<any>>
}

const DropInHeader = ({ params, setParams }: DropInHeaderProps) => {
  return (
    <div className="">
      <h4 className="text-14 w-600">Search attendees</h4>
      <div
        className="flex gap-10px mt-10px align-center"
        // style={{ gridTemplateColumns: '94% 6%' }}
      >
        <input
          type="text"
          className="input-style w-full flex-1"
          style={{ paddingLeft: '10px' }}
          //   value={searchval}
          //   onChange={e => setSearchVal(e.target.value)}
        />
        <div className="w-40px h-40px radius-rounded border-1px flex align-center justify-center">
          <CalendarBlank size={20} color="#000" />
        </div>
      </div>

      <div className="pt-20px filters-header">
        <div className="flex gap-8px align-center">
          <button className="button-otuliner-bordered">
            <MagnifyingGlass size={20} color="#000" />
          </button>
          <h4 className="text-14 w-500">Filter by:</h4>
          <button className="button-otuliner-bordered">
            Attendee age <CaretDown size={20} color="#000" />
          </button>
          <button className="button-otuliner-bordered">
            Gender <CaretDown size={20} color="#000" />
          </button>
          <button className="button-otuliner-bordered">
            School <CaretDown size={20} color="#000" />
          </button>
          <button className="button-otuliner-bordered">
            Grade <CaretDown size={20} color="#000" />
          </button>
        </div>
        <div className="flex justify-start align-center gap-8px">
          <h4 className="text-14 w-500">Sort by:</h4>
          <button className="button-otuliner-bordered">
            <SortAscending /> First name <CaretDown size={20} color="#000" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default DropInHeader
